module.exports = __webpack_public_path__ + "static/speakers_preview.7245c605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/speakers_preview.jpg
// module id = 692
// module chunks = 213534597649335